import { IMessage } from "@roketus/web-toolkit";
import { isPositiveMessageEntity } from "../../../domain/entities/messages/positiveEntity";
import { POSITIVE_SIGNUP } from "../../../domain/specs/positiveCodes";

export const isSignUpSuccess = (message: IMessage): boolean => {
  return isPositiveMessageEntity(message) && message.data === POSITIVE_SIGNUP;
};
